import css from './style.module.scss';
import {FC, useRef} from "react";
import {easeOutQuart, getPrizeIndex, initSpin} from "./logic";
import {clickAudio, spinAudio} from "../../utils/audio";
import {delay} from "../../utils/delay";

type Props = {
    spinN: 1 | 2 | 3 | 4,
    chosen: number[],
    onSpin: (prize: number) => void
}

const Wheel: FC<Props> = ({
    spinN,
    chosen,
    onSpin
}) => {

    const isSpinningRef = useRef(false);
    const wheelRef = useRef<HTMLDivElement>(null);
    const degreeRef = useRef(0);

    let text = "";
    switch (spinN) {
        case 1:
            text = "Tap to spin! ";
            break;
        case 2:
            text = "2 spins left!";
            break;
        case 3:
            text = "Last spin!";
            break;
        case 4:
            text = "Wait a few secs…";
            break;
    }

    function spinHandler(){
        if(isSpinningRef.current || spinN > 3) return;
        isSpinningRef.current = true;
        startSpin();
    }

    function startSpin() {
        clickAudio.play();
        const [delta, prize] = initSpin(degreeRef.current, spinN, [...chosen]);
        animation(delta, prize);
    }

    function animation(delta: number, prize: number) {
        let start = performance.now();
        const duration = 3000;
        let prevSection = -1;
        spinAudio.play();
        requestAnimationFrame(function animate(time) {
            let timeFraction = (time - start) / duration;
            if (timeFraction > 1) timeFraction = 1;

            let progress = easeOutQuart(timeFraction, degreeRef.current, delta, 1);

            const degree = progress % 360;
            draw(degree);
            const currentSection = getPrizeIndex(degree);
            if(currentSection !== prevSection){
                // spinAudio.pause();
                // spinAudio.currentTime = 0;
                prevSection = currentSection;
                // spinAudio.play();
            }

            if (timeFraction < 1) {
                requestAnimationFrame(animate);
            }
            else{
                degreeRef.current += delta % 360;
                onSpinEnd(prize);
            }

        });
    }

    function draw(degree: number) {
        if(wheelRef.current === null) return;
        wheelRef.current.style.transform = `rotate(${degree}deg)`;
    }

    async function onSpinEnd(prize: number) {
        await delay(500);
        onSpin(prize);
        isSpinningRef.current = false;
    }


    return (
        <div className={css.wrapper} onClick={spinHandler}>
            <div className={css.text}>{text}</div>
            <div className={css.wheelBox}>
                <div className={css.wheel} ref={wheelRef}>
                    <img src={"images/wheel.png"} alt="wheel"/>
                </div>
                <div className={css.pointer}>
                    <img src={"images/wheel-pointer.png"} alt={"Wheel Pointer"}/>
                </div>
            </div>
        </div>
    )
}

export default Wheel;